<template>
    <hollow-dots-spinner
        :animation-duration="1000"
        :dot-size="10"
        :dots-num="3"
        :color="'white'"
     />
</template>

<script>

import {HollowDotsSpinner} from 'epic-spinners'
  export default {
    components: {
      HollowDotsSpinner
    }
  }
</script>
